module.exports = __webpack_public_path__ + "img/arrow-down-sp.5e85d83b.svg";